import React from 'react';
import Banner from '../Components/Banner';
import { useLanguage } from '../context/LanguageContext';
import { serviceCatalog } from '../data/serviceCatalog';
import { Link } from 'react-router-dom';

function Services() {
  const { t, lang } = useLanguage();

  return (
    <div className="page-wrap">
      <Banner
        pageName={t.pages.services}
        pageLink="/services"
        subtitle={t.services.subtitle}
        eyebrow="Innovative Horizons"
        image="https://images.unsplash.com/photo-1551434678-e076c223a692?auto=format&fit=crop&w=1800&q=80"
      />

      <section className="section">
        <div className="container">
          <div className="section-title center">
            <div className="eyebrow">Portfolio</div>
            <h2>{t.services.title}</h2>
            <p>{t.services.intro}</p>
          </div>

          <div className="grid-3">
            {serviceCatalog.map((service) => (
              <article className="service-card" key={service.slug}>
                <div
                  className="service-visual"
                  style={{ backgroundImage: `url(${service.image})` }}
                />

                <div className="service-body">
                  <div className="service-icon">
                    <i className={service.cName} />
                  </div>

                  <h3>{service.title[lang]}</h3>
                  <p>{service.desc[lang]}</p>

                  <ul className="check-list">
                    {service.bullets[lang].map((item) => (
                      <li key={item}>{item}</li>
                    ))}
                  </ul>

                  <Link
                    to={`/services/${service.slug}`}
                    className="nav-cta service-link-btn"
                  >
                    {t.common.learnMore}
                  </Link>
                </div>
              </article>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}

export default Services;